<script lang="ts">
  import { m } from "#messages";
  import EntranceFooter from "#lib/entrance/EntranceFooter.svelte";
  import EntranceHeader from "#lib/entrance/EntranceHeader.svelte";
  import ProductHero from "#lib/products/ProductHero.svelte";
  import ProductSections from "#lib/products/ProductSections.svelte";
  import type { ProductSection } from "#lib/products/ProductSections.svelte";
  import Meta from "#lib/seo/Meta.svelte";
  import { fitOf } from "#lib/shots/bands.ts";
  import CtaBand from "#lib/site/CtaBand.svelte";
  import Window from "#lib/site/Window.svelte";
  import type { PageProps } from "./$types.ts";

  let { data }: PageProps = $props();

  const SECTIONS: readonly ProductSection[] = $derived([
    {
      id: "giveaways",
      title: null,
      lede: null,
      tiles: [
        {
          preview: "giveaway-impact",
          title: m.features_giveaway_effect(),
          body: m.features_giveaway_effect_body(),
          plan: m.pricing_on_request(),
        },
      ],
    },
  ]);
</script>

<Meta title={m.meta_campaigns_title()} description={m.meta_campaigns_description()} />

<EntranceHeader me={data.me} />

<main class="overflow-x-clip">
  <ProductHero
    headline={m.products_campaigns_headline()}
    lede={m.products_campaigns_lede()}
    testId="campaigns-hero"
  >
    {#snippet picture()}
      <Window preview="giveaway" fit={fitOf("giveaway")} alt={m.features_group_giveaways()} />
    {/snippet}
  </ProductHero>

  <ProductSections sections={SECTIONS} testId="campaigns" />

  <CtaBand title={m.products_closing_title()} body={m.products_closing_body()} />
</main>

<EntranceFooter />
